import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { FaUser, FaLock, FaChevronRight } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FaSquarePhone } from "react-icons/fa6";
import Swal from "sweetalert2";

const initialState = {
  UserName: "",
  role: "user",
  userpassword: "",
  UserDob: "",
  mobileNo: "",
  email: "",
  gender: "",
  createdbyrole: "user",
};

const Registrationpage = ({ handleSignInMode }) => {
  const [state, setState] = useState(initialState);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const {
    UserName,
    role,
    userpassword,
    UserDob,
    mobileNo,
    email,
    gender,
    createdbyrole,
  } = state;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (
      !UserName ||
      !UserDob ||
      !mobileNo ||
      !email ||
      !gender ||
      !userpassword ||
      !mobileRegex.test(mobileNo) ||
      !emailRegex.test(email) ||
      !passwordRegex.test(userpassword)
    ) {
      let errorMessage = "";
      if (!UserName) errorMessage += "Please fill the Username.\n";
      if (!UserDob) errorMessage += "Please fill the Date of Birth.\n";
      if (!mobileNo) errorMessage += "Please fill the Mobile Number.\n";
      if (!email) errorMessage += "Please fill the Email.\n";
      if (!gender) errorMessage += "Please select Gender.\n";
      if (!userpassword) errorMessage += "Please fill the Password.\n";
      if (mobileNo && !mobileRegex.test(mobileNo))
        errorMessage += "Mobile number must be 10 digits.\n";
      if (email && !emailRegex.test(email))
        errorMessage += "Enter a valid email address.\n";
      if (userpassword && !passwordRegex.test(userpassword))
        errorMessage +=
          "Password must have 8 chars, uppercase, lowercase, number & symbol.\n";

      alert(errorMessage);
      return;
    }

    try {
await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/post/memberegister/signup`,
      {
          UserName,
          role,
          userpassword,
          UserDob,
          mobileNo,
          email,
          gender,
          createdbyrole,
        }
      );

      Swal.fire({
        title: "Success!",
        text: "Sign up successful! Please sign in.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        setState(initialState);
        // navigate("/"); // enable if needed
      });
    } catch (err) {
      if (err.response && err.response.data) {
        alert(err.response.data);
      } else {
        alert("Something went wrong. Please try again later.");
      }
    }
  };

  return (
    <div className="signup__heading">
      <div className="ss-container">
        <form className="sign-up-form" onSubmit={handleSubmit}>
          <h2 className="title">Sign up</h2>

          {error && <div className="error-message">{error}</div>}

          <div className="signup__div">
            <div className="signup__field">
              <FaUser />
              <input
                type="text"
                name="UserName"
                placeholder="User Name"
                className="signup__input"
                value={UserName}
                onChange={handleInputChange}
              />
            </div>

            <div className="signup__field">
              <FaLock />
              <input
                type="password"
                name="userpassword"
                placeholder="Password"
                className="signup__input"
                value={userpassword}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="signup__div">
            <div className="signup__field">
              <FaSquarePhone />
              <input
                type="number"
                name="mobileNo"
                placeholder="Mobile Number"
                className="signup__input"
                value={mobileNo}
                onChange={handleInputChange}
              />
            </div>

            <div className="signup__field">
              <IoMail />
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="signup__input"
                value={email}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="signup__div">
            <input
              type="date"
              name="UserDob"
              className="signup__input"
              value={UserDob}
              onChange={handleInputChange}
            />

            <select
              name="gender"
              className="signup__input"
              value={gender}
              onChange={handleInputChange}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <button className="button signup__submit" type="submit">
            Sign Up Now <FaChevronRight />
          </button>

          <p className="social__text">
            Already have an account?{" "}
            <button
              type="button"
              className="signin__button"
              onClick={handleSignInMode}
            >
              Sign in
            </button>
          </p>

          <p className="signin__hompage">
            Go to <Link to="/">Homepage</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Registrationpage;
